module.exports = __webpack_public_path__ + "img/icon_sec2_1@2x.2b124cb0.png";